import React, { useState } from 'react'
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchBinReport, fetchHeroReport } from '../../modules/reports'
import moment from 'moment'
import { groupBy, isEmpty, isNull, isUndefined, some } from 'lodash'
import { compose, graphql } from 'react-apollo'
import { GET_CATEGORY_LIST } from '../../graphql/queries'
import { DATE, ENDPOINT, HERO_TYPE } from '../../utils/constants'
import { ButtonEx } from '../../styles/button.style'

const { RangePicker } = DatePicker

const Reports = ({ form, data }) => {
  const dispatch = useDispatch()
  const { validateFields, getFieldDecorator } = form
  const [filterOptions, setFilterOptions] = useState({
    size: 20,
    page: 0
  })
  const [categoryOption, setCategoryOption] = useState(true)
  const [typeOption, setTypeOption] = useState(true)
  const [heroOption, setHeroOption] = useState(true)
  const [heroIds, setHeroIds] = useState([])
  const [date, setDate] = useState([moment(new Date()), moment(new Date())])

  const { transactionList, heroList, isLoading } = useSelector(
    (state) => ({
      heroList: state.reports.heroList,
      transactionList: state.reports.transactionList,
      isLoading: state.reports.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchHeroReport())
    await dispatch(fetchBinReport(filterOptions))
  }

  useDeepEffect(() => {
    form.setFieldsValue({
      categoryId: [0],
      heroType: [0],
      heroId: [0]
    })
    fetchData()
  }, [])

  useDeepEffect(() => {
    if (!isEmpty(heroList)) {
      setHeroSelect()
    }
  }, [heroList])

  async function setHeroSelect() {
    const arr = groupBy(heroList, 'heroId')
    const results = []
    for (const item of Object.keys(arr)) {
      results.push({
        heroId: item,
        heroName: arr[item][0].heroName
      })
    }
    setHeroIds(results)
  }

  async function onShowSizeChange(current, pageSize) {
    filterOptions.size = pageSize
    filterOptions.page = 0
    setFilterOptions(filterOptions)
    await dispatch(fetchBinReport(filterOptions))
  }

  async function onChange(page) {
    filterOptions.page = page - 1
    setFilterOptions(filterOptions)
    await dispatch(fetchBinReport(filterOptions))
  }

  function onDateChange(date) {
    if (!isNull(date)) {
      setDate(date)
    } else {
      setDate([moment(new Date()), moment(new Date())])
    }
  }

  function handleChange(value) {
    const isAll = some(value, (item) => {
      return item === '0'
    })

    if (isAll) {
      setCategoryOption(true)
      // setCategorySelect(['all'])
      form.setFieldsValue({
        category: ['0']
      })
    } else {
      setCategoryOption(false)
      // setCategorySelect(value)
    }
  }

  function handleTypeChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })

    if (isAll) {
      setTypeOption(true)
    } else {
      setTypeOption(false)
    }
  }

  function handleHeroChange(value) {
    const isAll = some(value, (item) => {
      return item === '0'
    })

    if (isAll) {
      setHeroOption(true)
    } else {
      setHeroOption(false)
    }
  }

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => (
        <span>{filterOptions.page * filterOptions.size + index + 1}</span>
      )
    },
    {
      title: 'ชื่อฮีโร่',
      dataIndex: 'heroName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ประเภทฮีโร่',
      dataIndex: 'heroType',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'บาร์โค้ดสินค้า',
      dataIndex: 'barcode',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'สินค้า',
      align: 'center',
      render: (text, record) => {
        return record.name && record.brand ? (
          <span>{`${record.name} ${record.brand}`}</span>
        ) : (
          '-'
        )
      }
    },
    {
      title: 'วัสดุที่ได้',
      dataIndex: 'materialName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ผู้ทิ้ง',
      dataIndex: 'user',
      align: 'center'
    },
    {
      title: 'วันที่ทิ้ง',
      dataIndex: 'datetime',
      align: 'center',
      render: (text, record) => {
        return moment(text).format('DD-MM-YYYY')
      }
    }
  ]

  const onClear = async (e) => {
    e.preventDefault()
    setFilterOptions((prevState) => {
      prevState.size = 20
      prevState.page = 0
      prevState.heroId = undefined
      prevState.heroType = undefined
      prevState.category = undefined
      prevState.keyword = undefined
      return prevState
    })

    form.setFieldsValue({
      keyword: '',
      categoryId: [0],
      heroType: [0],
      heroId: [0]
    })

    await setHeroSelect()
    await dispatch(fetchBinReport(filterOptions))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        filterOptions.keyword = values.keyword || undefined

        if (values.heroId) {
          if (values.heroId[0] === 0) {
            filterOptions.heroId = undefined
          } else {
            filterOptions.heroId = !isUndefined(values.heroId)
              ? values.heroId.join()
              : undefined
          }
        }

        if (values.categoryId) {
          if (values.categoryId[0] === 0) {
            filterOptions.categoryId = undefined
          } else {
            filterOptions.categoryId = !isUndefined(values.categoryId)
              ? values.categoryId.join()
              : undefined
          }
        }

        if (values.heroType) {
          if (values.heroType[0] === 0) {
            filterOptions.heroType = undefined
          } else {
            filterOptions.heroType = !isUndefined(values.heroType)
              ? values.heroType.join()
              : undefined
          }
        }
        filterOptions.page = 0
        setFilterOptions(filterOptions)
        await dispatch(fetchBinReport(filterOptions))
      }
    })
  }

  async function onSearch(value) {
    if (value) {
      const arr = heroIds.filter((hero) => {
        return hero.heroName.toString().toLowerCase().includes(value.toString())
      })
      setHeroIds(arr)
    } else {
      await setHeroSelect()
    }
  }

  function getHeroIdUrl() {
    const heroId = form.getFieldValue('heroId')
    if (heroId[0] !== 0) {
      return `&heroId=${heroId.join()}`
    }
    return ''
  }

  function getHeroTypeUrl() {
    const heroType = form.getFieldValue('heroType')
    if (heroType[0] !== 0) {
      return `heroType=${heroType.join()}`
    }
    return ''
  }

  function getCategoryUrl() {
    const category = form.getFieldValue('categoryId')
    if (category[0] !== 0) {
      return `categoryId=${category.join()}`
    }
    return ''
  }

  return (
    <Row type="flex" gutter={[8, 8]}>
      <Col span={24}>
        <Row style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row type="flex" justify="end" gutter={8}>
              <Col>
                <RangePicker
                  value={date}
                  onChange={onDateChange}
                  format={DATE.FORMAT}
                />
              </Col>
              <Col>
                <ButtonEx color="#6ebf4b" type="primary">
                  {!isUndefined(form.getFieldValue('heroId')) ? (
                    <a
                      href={
                        ENDPOINT +
                        `/bin/export-admin?${getHeroIdUrl()}${getHeroTypeUrl()}${getCategoryUrl()}&from=${moment(
                          date[0]
                        ).format(DATE.FORMAT)}&to=${moment(date[1]).format(
                          DATE.FORMAT
                        )}`
                      }
                      download>
                      Export Data
                    </a>
                  ) : (
                    <span>Select Hero</span>
                  )}
                </ButtonEx>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            onSubmit={handleSubmit}>
            <Row gutter={8}>
              <Col span={18}>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ค้นหาข้อมูลการทิ้งขยะ">
                      {getFieldDecorator('keyword')(
                        <Input placeholder="บาร์โค้ด ชื่อสินค้า ยี่ห้อสินค้า" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ฮีโร่">
                      {getFieldDecorator('heroId')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleHeroChange}
                          onSearch={onSearch}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {heroIds.map((hero, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={hero.heroId}
                                disabled={heroOption}>
                                {hero.heroName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ประเภทฮีโร่">
                      {getFieldDecorator('heroType')(
                        <Select
                          mode="multiple"
                          onChange={handleTypeChange}
                          showArrow={true}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {HERO_TYPE.map((type, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={type}
                                disabled={typeOption}>
                                {type}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="หมวดของวัสดุ">
                      {getFieldDecorator('categoryId')(
                        <Select
                          mode="multiple"
                          onChange={handleChange}
                          showArrow={true}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {data.categories &&
                            data.categories.map((category, index) => {
                              return (
                                <Select.Option
                                  key={index}
                                  value={category.id}
                                  disabled={categoryOption}>
                                  {category.name}
                                </Select.Option>
                              )
                            })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <Form.Item label="" style={{ marginTop: '1.75rem' }}>
                  <Row gutter={8} type="flex">
                    <Col>
                      <Button type="primary" htmlType="submit">
                        ค้นหา
                      </Button>
                    </Col>
                    <Col>
                      <Button type="danger" onClick={(e) => onClear(e)}>
                        เคลียร์
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Table
          scroll={{ x: 1200 }}
          rowKey={(record) => {
            return record.id
          }}
          bordered
          dataSource={transactionList.content}
          columns={columns}
          loading={isLoading}
          pagination={{
            current: !isEmpty(transactionList)
              ? transactionList.pageable.pageNumber + 1
              : 1,
            pageSize: transactionList.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: transactionList.totalElements
          }}
        />
      </Col>
    </Row>
  )
}

const WrappedReports = Form.create({
  name: 'WrappedReports'
})(Reports)

export default compose(graphql(GET_CATEGORY_LIST))(WrappedReports)



// WEBPACK FOOTER //
// ./src/pages/Reports/index.js